import { AlbumCollectionTypeEnum } from '@/entities/album-collections'
import { type CreateOrUpdateAlbumCollectionModel } from '@/shared/api'

import { type AlbumCollectionFormCommonInformationModel } from '../ui/AlbumCollectionFormCommonInformation'

export function getAlbumCollectionRequestByFormValues(
  values: AlbumCollectionFormCommonInformationModel,
): CreateOrUpdateAlbumCollectionModel {
  return {
    name: values.name,
    description: values.description,
    type: AlbumCollectionTypeEnum.Podcast,
    authorId: values.authorId,
    coauthorIds: values.coauthorIds ?? null,
    pictureFileId: values.pictureFile?.id ?? '',
  }
}
